import TYPES from '@/modules/shared/types';

// Domain
import {
  InvestmentSuggestionRepository,
} from '@/modules/investment-suggestion/domain/repositories/investment-suggestion-repository';
import {
  InvestmentSuggestionEntity,
} from '@/modules/investment-suggestion/domain/entities/investment-suggestion-entity';
import {
  InvestmentSuggestionDto,
} from '@/modules/investment-suggestion/domain/dtos/investment-suggestion-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestmentSuggestionHttpRepository implements InvestmentSuggestionRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/investment-suggestion/`;

  get(): Promise<InvestmentSuggestionEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }

  create(investment_suggestion_dto: InvestmentSuggestionDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}action/`, 'POST', investment_suggestion_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
